import { useEffect, useState } from 'react';
import AppLayout from '@cloudscape-design/components/app-layout';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import { applyMode, Mode } from '@cloudscape-design/global-styles';
import { AuthState, initAuth, signIn } from './auth';
import OverridesTable from './OverridesTable';

applyMode(Mode.Dark);

export default function App() {
  const [auth, setAuth] = useState<AuthState | null | undefined>(undefined);

  useEffect(() => {
    initAuth().then(setAuth);
  }, []);

  if (auth === undefined) {
    return (
      <AppLayout
        content={
          <Box textAlign="center" padding="xxl">
            Loading...
          </Box>
        }
        navigationHide
        toolsHide
      />
    );
  }

  if (!auth) {
    return (
      <AppLayout
        navigationHide
        toolsHide
        content={
          <ContentLayout header={<Header variant="h1">📅 ASPEN — Tester Overrides</Header>}>
            <Box textAlign="center" padding="xxl">
              <SpaceBetween size="m">
                <Box>You need to sign in to manage tester overrides.</Box>
                <Button variant="primary" onClick={() => void signIn()}>
                  Sign In with Amazon Federate
                </Button>
              </SpaceBetween>
            </Box>
          </ContentLayout>
        }
      />
    );
  }

  return (
    <AppLayout
      navigationHide
      toolsHide
      content={
        <ContentLayout
          header={
            <Header variant="h1" description={auth.email}>
              📅 ASPEN — Tester Overrides
            </Header>
          }
        >
          <OverridesTable idToken={auth.idToken} />
        </ContentLayout>
      }
    />
  );
}
